import useSWR from 'swr';
import useSdk from 'helpers/hooks/useSdk';
import { revalidateOptions } from 'frontastic';

const useGoogleMapsApiKey = () => {
  const sdk = useSdk();
  const result = useSWR(
    `/action/yggdrasil/getGoogleMapsApiKey`,
    () => {
      return sdk.callAction<{ apikey: string }>({
        actionName: 'yggdrasil/getGoogleMapsApiKey',
      });
    },
    revalidateOptions,
  );

  return result.data?.isError ? undefined : result.data?.data.apikey;
};

export default useGoogleMapsApiKey;
